module.exports = __webpack_public_path__ + "img/home.5cf79b77.svg";